'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../helpers/strings.js');
require('../helpers/date.js');
require('../helpers/arrays.js');
require('../helpers/language.js');
require('../helpers/numbers.js');
require('../helpers/currency.js');
require('../helpers/dom.js');
var debounce = require('../helpers/debounce.js');
require('../helpers/throttle.js');
require('../helpers/functions.js');
require('../helpers/session.js');
require('../helpers/forms.js');
require('../helpers/keys.js');
require('../helpers/game.js');
require('../helpers/game-category.js');
require('../helpers/script.js');
require('../helpers/events.js');
require('../helpers/password.js');
require('../helpers/storage.js');
require('../helpers/theming.js');
require('../helpers/objects.js');
require('../helpers/slots.js');
require('../helpers/phone.js');
var validators = require('vuelidate/lib/validators');

function debounceValidator(validator, delayMs, rules = []) {
  let resolver = () => null;
  let rejecter = () => null;
  const debouncedValidator = debounce.debounce(function(...args) {
    const result = validator.apply(this, args);
    if (result instanceof Promise) {
      result.then(resolver, rejecter);
      return;
    }
    resolver(result);
  }, delayMs);
  return function(...values) {
    if (rules.length && !validators.and(...rules)(...values)) {
      return false;
    }
    return new Promise((resolve, reject) => {
      resolver = resolve;
      rejecter = reject;
      debouncedValidator(...values);
    });
  };
}

exports.debounceValidator = debounceValidator;
